import { render } from "./CreateChannel.vue?vue&type=template&id=4aaf4760"
import script from "./CreateChannel.vue?vue&type=script&lang=js"
export * from "./CreateChannel.vue?vue&type=script&lang=js"

import "./CreateChannel.vue?vue&type=style&index=0&id=4aaf4760&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__